import React from 'react';
import { Link } from 'react-router';

import './ProfileNav.scss';

export const ProfileNav = () => (
  <ul className="ProfileNav">
    <Link to="/advisor/profile/about" className="ProfileNav__entry" activeClassName="ProfileNav__entry--active">
      About
    </Link>
    <Link to="/advisor/profile/self-intro" className="ProfileNav__entry" activeClassName="ProfileNav__entry--active">
      Introduce Yourself
    </Link>
    <Link to="/advisor/profile/experience" className="ProfileNav__entry" activeClassName="ProfileNav__entry--active">
      Experience
    </Link>
    <Link to="/advisor/profile/education" className="ProfileNav__entry" activeClassName="ProfileNav__entry--active">
      Education
    </Link>
    <Link to="/advisor/profile/coachingpreferences" className="ProfileNav__entry" activeClassName="ProfileNav__entry--active">
      Coaching Preferences
    </Link>
  </ul>
);

export default ProfileNav;



// WEBPACK FOOTER //
// ./src/routes/advisor/routes/Profile/components/ProfileNav/index.js